import Hls from 'hls.js';
/**
 * v36 — Flower 엔진의 플레이어: **앱이 넘긴 `<video>` 한 쌍의 [0] 하나에 hls.js 하나** (`docs/72` §5.2).
 *
 * - **`Hls.isSupported()` 를 다시 묻지 않는다.** 이 플레이어가 서는 것은 `receiverEngineFor()` 가 `flower` 를 낼
 *   때뿐이고, 그것은 `resolvePlayerKind() === 'hls'` 일 때뿐이다 — ONAIR(`use-onair-player.ts`)·홈 프리뷰와 같은
 *   「그 판정을 거친 자리」다(「`new Hls()` 를 부르는 자리를 늘리지 말 것」의 단서).
 * - **`<video>` 를 만들지 않는다**(셋째 `<video>` 금지 · 규칙 27·82). 쌍은 `bloom-app` 의 `playbackBuffers()` 가 쥐고
 *   인자로 온다 — WebKit 의 재생 허가가 엘리먼트 단위라 채널·엔진을 건너 같은 엘리먼트를 쓴다.
 * - **`attachMedia` 가 먼저다.** Flower 의 hls.js 판별은 `media` 가 있고 `levels` 가 배열이어야 한다 — 아니면 원래
 *   주소를 그대로 돌려주고 아무것도 가로채지 않는데 오류도 없다(`docs/72` §5.2).
 * - 둘째 `<video>` 는 숨긴 채 쉰다(`opacity` 0 · 음소거). 보조 경로(§3.5)가 들어오면 그때 쓴다.
 * - 소리는 `muted` 축이다 — 설정의 소리 끄기는 `volume` 축이라(`audio-muted.ts`) 서로 건드리지 않는다.
 * - **붙이기 기다림에는 끝이 있다**(`attachTimeoutMs`). 같은 `<video>` 에 다른 hls.js 가 먼저 `src` 를 덮으면 이 hls.js 의
 *   MediaSource 는 끝내 열리지 않아 `MEDIA_ATTACHED` 가 오지 않는다. 앱은 Flower 생성을 한 줄로 세우므로(`create-receiver.ts`)
 *   끝없이 기다리는 하나가 뒤의 생성을 전부 막는다 — 시간이 지나면 hls.js 를 없애고 거절한다.
 */
/** 붙이기를 기다리는 상한. 루프백에서 `sourceopen` 은 수 ms 다 — 넉넉히 잡는다 */
export const FLOWER_ATTACH_TIMEOUT_MS = 5_000;
export async function createFlowerPlayer({ container, buffers, attachTimeoutMs = FLOWER_ATTACH_TIMEOUT_MS, }) {
    const [front, back] = buffers;
    for (const el of buffers) {
        el.playsInline = true;
        el.preload = 'auto';
        // `hls-player.ts` 와 같은 자리·같은 모양 — 엔진을 오가도 화면이 튀지 않게.
        el.style.cssText =
            'position:absolute;top:0;left:0;width:100%;height:100%;' +
                'object-fit:contain;background:#000;opacity:0;z-index:1;';
        container.appendChild(el);
    }
    back.muted = true;
    front.muted = false;
    front.style.opacity = '1';
    front.style.zIndex = '2';
    const hls = new Hls({ enableWorker: true });
    await new Promise((resolve, reject) => {
        const timer = setTimeout(() => {
            hls.destroy();
            reject(new Error(`hls.js 가 ${String(attachTimeoutMs)}ms 안에 <video> 에 붙지 않았다(MEDIA_ATTACHED 없음)`));
        }, attachTimeoutMs);
        hls.once(Hls.Events.MEDIA_ATTACHED, () => {
            clearTimeout(timer);
            resolve();
        });
        hls.attachMedia(front);
    });
    return {
        hls,
        media: front,
        destroy: () => {
            hls.destroy();
            for (const el of buffers) {
                el.pause();
                el.removeAttribute('src');
                el.load();
                el.muted = true;
            }
        },
    };
}
//# sourceMappingURL=flower-player.js.map